"use client";

import { Checkbox } from "@/components/ui/checkbox";
import {
  setHolidayFilters,
  useHolidayFilter,
} from "@/feature/holiday/search/state/extract-holiday-filter-slice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { HolidayAccordion } from "./holiday-accordion";

function getDurationLabel(value: string) {
  if (value === "1-3") return "1-3 Days";
  if (value === "4-6") return "4-6 Days";
  return "7+ Days";
}

export function HolidayDurationFilter() {
  const dispatch = useAppDispatch();
  const { selectedOption, defaultOption } = useAppSelector(useHolidayFilter);
  const options = defaultOption.durations;

  if (!options.length) {
    return null;
  }

  return (
    <HolidayAccordion value="duration" label="Duration">
      <div className="space-y-2">
        {options.map((duration) => (
          <label
            key={duration}
            className="flex items-center gap-2 text-sm text-muted-foreground"
          >
            <Checkbox
              checked={selectedOption.durations.includes(duration)}
              onCheckedChange={(checked) => {
                if (checked === "indeterminate") return;

                const next = selectedOption.durations.includes(duration)
                  ? selectedOption.durations.filter((item) => item !== duration)
                  : [...selectedOption.durations, duration];
                dispatch(setHolidayFilters({ durations: next }));
              }}
            />
            <span>{getDurationLabel(duration)}</span>
          </label>
        ))}
      </div>
    </HolidayAccordion>
  );
}

